import { Box, Typography } from '@mui/material';

// components/ReadOnlyMultiValue.tsx
export function ReadOnlyMultiValue({
  formLabel,
  options,
  selectedValues,
}: {
  formLabel: string;
  options: { key: string; value: string }[];
  selectedValues: string[];
}): JSX.Element {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 700,
          color: 'rgba(0, 0, 0, 0.6)',
          letterSpacing: '0.5px',
          mb: 1,
        }}>
        {formLabel}
      </Typography>
      {options
        .filter((opt) => selectedValues.includes(opt.key))
        .map((opt) => (
          <Typography key={opt.key} sx={{ fontSize: 14, color: 'text.secondary' }}>
            • {opt.value}
          </Typography>
        ))}
    </Box>
  );
}
